export const mainMediaMobile = '(max-width: 1024px)';

export const dotsToComma = (value) => {
    return value && value.toString().replace(/\./g, ',');
};
